// extracted by mini-css-extract-plugin
export default {"Checkbox":"style_Checkbox__UZH5K","ThreeWayCheckbox":"style_ThreeWayCheckbox__2iXlX"};